import { error } from "shelljs";

export default {
  header: {
    nav: "首页",
    nav2: "支付产品",
    nav2_1: "全球收单",
    nav2_2: "全球收款账户",
    nav2_3: "全球付款",
    nav3: "技术服务",
    nav3_1: "条码支付系统",
    nav3_2: "即时通讯工具",
    nav4: "开发者",
    nav4_1: "API文档",
    nav5: "关于我们",
    nav5_1: "公司简介",
    nav5_2: "联系我们",
    login: "系统登录"
  },
  footer: {
    statement: "反洗钱声明",
    termuse: "服务协议",
    privacy: "隐私政策",
    copyright: "© Singloh Technology Limited 版权所有",
    icp: "工信部备案号:浙ICP备2024129281号-3"
  },
  home: {
    banner1: "全面解决您的",
    banner2: "支付需求",
    banner3:
      "我们致力于为企业提供全方位的全球支付解决方案。无论是全球收单、全球付款，还是全球收款账户，我们的产品都通过整合多种国家支付渠道和本地支付方式，帮助企业轻松应对跨境交易的复杂性。",
    ref: "咨询合作",
    part1: {
      tit: "全球收单，畅行世界",
      tips: "安全高效，覆盖全球的收单解决方案",
      p:
        "接入 Visa、MasterCard、JCB等国际卡组织，为您的业务提供全球覆盖的支付解决方案",
      p2: "轻松支持全球大部分主流钱包收单，满足多样化支付需求，提升支付成功率",
      p3: "支持欧美、非洲、亚太等地区数百种本地支付方式",
      btn_txt: "了解详情"
    },
    part2: {
      tit: "全球付款，安全高效",
      tips: "轻松管理国际付款，覆盖全球市场",
      p: "多样化付款渠道",
      p2: "广泛覆盖",
      p3: "多币种支持",
      p4: "高效的支付处理",
      p5: "快速到账"
    },
    part3: {
      tit: "全球账户，多币管理",
      tips: "专为跨境贸易企业量身打造，轻松管理境外多币种资金",
      p: "接入 境外本地账户，手续费更低，更便捷",
      p2: "高效的资金结算服务，确保资金快速到账",
      p3: "通过集中管理的收款账户，轻松进行全球范围内的资金调配和管理"
    },
    sec1: {
      tit: "创新能力拓展业务",
      tit2: "新维度",
      tips:
        "我们不仅提供全球领先的支付解决方案，还具备强大的附加能力，助力全球金融科技创新",
      subtit: "条码支付系统",
      subtit_p:
        "专为各国央行和金融机构设计的二维码支付系统，提升支付效率和用户体验。我们成功为多个国家搭建了高效的QR支付系统，推动本地化支付发展",
      subtit2: "即时通讯工具",
      subtit2_p:
        "我们自行开发的即时通讯工具，提供安全、快速的沟通解决方案，并且融合多种支付场景需求，提供全方位的沟通与支付解决方案。"
    },
    sec2: {
      tit: "全面的API文档支持",
      tit2: "助力无缝集成",
      tips:
        "我们提供详尽的API文档，帮助开发者轻松集成我们的支付解决方案，快速实现功能扩展。",
      part1: {
        tit: "全面详细的",
        tit2: "接口文档",
        tips: "包含详细的接口说明",
        tips2: "请求/响应格式、参数说明等"
      },
      part2: {
        tit: "丰富的",
        tit2: "使用示例",
        tips: "提供实际的代码示例",
        tips2: "请求/帮助快速实现集成"
      },
      part3: {
        tit: "灵活的",
        tit2: "集成支持",
        tips: "支持多种编程语言和平台",
        tips2: "请求/方便自定义集成"
      },
      part4: {
        tit: "技术支持和",
        tit2: "社区资源",
        tips: "提供1v1技术支持",
        tips2: "请求/迅速解答集成过程中的问题"
      }
    },
    con_t: "即刻启用",
    con_t2: "开启全球收单之旅",
    news: {
      tit: "新闻资讯"
    }
  },
  acq: {
    th: "全球收单",
    tit: "轻松连接全球市场",
    tit2:
      "轻松接入全球支付网络，支持境外多币种、多渠道的支付方式，为境外客户提供无缝的支付体验",
    sec1: {
      tit: "全球化的支付方式",
      p1:
        "NuwaPay 深度整合 Visa、MasterCard、JCB 等国际卡组织，覆盖全球数十亿持卡用户，帮助境外企业无缝链接国际市场，优化支付流程，提升转化率。",
      p2:
        "NuwaPay 支持全球大部分主流钱包收单，覆盖欧美、非洲、亚太等市场。我们平台确保每笔交易快速、安全，减少支付障碍，提升转化率。",
      p3:
        "NuwaPay 通过全球支付牌照网络，支持一键接入数百种本地支付方式，帮助境外企业轻松拓展亚太、欧洲、拉美、非洲等市场，连接更多海外消费者。",
      th4: "支持的钱包类型"
    },
    sec2: {
      t1: "多样化支付选项",
      tips1:
        "系统提供各种支付方式，包括信用卡、借记卡、电子钱包、银行转账等，能够满足不同消费者的支付偏好和需求",
      t2: "无国界交易",
      tips2:
        "接受超过150种货币的支付，轻松接入我们的灵活支付基础设施，实现全球业务的快速扩展与高效管理",
      t3: "多元化技术方式对接",
      tips3: "支持灵活的技术集成方案，收银台、API 直连等多种接入方式",
      t4: "先进的支付安全技术",
      tips4:
        "符合PCI-DSS（支付卡行业数据安全标准）等国际安全认证标准， 确保交易数据和用户信息的安全。"
    },
    sec3: {
      tit: "智能风控引擎，保障交易安全",
      t1: "合规性保障",
      tips1:
        "符合国际支付行业合规要求，保障交易的合法性和合规性等，能够满足不同消费者的支付偏好和需求",
      t2: "实时风险监控",
      tips2: "通过先进的算法和机器学习技术，实时识别和应对潜在风险和异常交易",
      t3: "拒付申诉服务",
      tips3: "专业拒付申诉服务，减少客户资金损失",
      t4: "多层次防护机制",
      tips4: "包括行为分析和地理位置验证等，全面保护交易安全。"
    },
    sec4: {
      tit: "多元化的解决方案",
      tit2: "无论您的客户在哪儿",
      tips:
        "我们的支付平台支持多种技术集成方式，包括自定义收银台、API直连等等。根据客户的具体需求，我们量身定制最优的集成方案，确保支付体验的灵活性和高效性。"
    }
  },
  acc: {
    th: "全球收款账户",
    tit: "全球收款账户，跨境资金管理的最佳选择",
    tit2: "为跨境贸易企业提供多币种账户，助力企业在全球市场中高效管理外币资金",
    th2: "随时随地 在线收款",
    sec1: {
      tit: "多币种本地账户",
      tips:
        "支持美元、欧元、英镑、日元等多种货币，便于企业在全球范围内收款和管理资金"
    },
    sec2: {
      t1: "跨境贸易支持",
      tips1:
        "简化国际收款流程，减少汇兑损失，提升资金周转效率，专为跨境贸易企业设计。",
      t2: "全球覆盖",
      tips2:
        "覆盖欧美、亚太、非洲等主要市场，无需开设多个银行账户即可轻松收款。",
      t3: "实时资金管理",
      tips3: "随时查看账户余额、交易记录和资金流动，提升财务透明度。 ",
      t4: "低成本运营",
      tips4: "减少跨境转账费用和时间，降低运营成本，优化资金使用效率。",
      t5: "安全可靠",
      tips5: "采用银行级别的安全标准和技术，保障资金安全和数据隐私。",
      t6: "自动化对账",
      tips6: "无缝集成财务系统，简化对账流程，减少错误。",
      t7: "合规性保障",
      tips7: "符合国际金融监管要求，确保资金流动合法合规。"
    }
  },
  pay: {
    th: "全球付款",
    tit: "全球付款，快速又安全",
    sec1: {
      t1: "全球支付覆盖",
      tips1:
        "支持110+国家和地区，包括欧美、亚太、拉美、非洲等主要市场，轻松实现全球资金转移",
      t2: "多种付款方式",
      tips2:
        "支持CHATS、SWIFT、ACH、FEDWIRE、SEPA等全球付款网络的同时接入多国本地支付网络，满足不同业务需求，有效降低成本。",
      t3: "快速到账",
      tips3: "大部分付款方式支持0-3日内到账，优化现金流管理。 ",
      t4: "安全保障",
      tips4: "采用先进的安全技术和风控机制，保障每笔交易的安全。",
      t5: "简化操作",
      tips5: "提供简便的操作界面和自动化流程，提高付款效率。"
    },
    sec2: {
      t1: "国家和地区",
      t2: "银行账户",
      t3: "移动钱包",
      t4: "取款网点"
    },
    africa: "非洲",
    asia: "亚洲",
    europe: "欧洲",
    latin: "拉丁美洲&加勒比海地区",
    north: "南美洲",
    oceania: "大洋洲"
  },
  system: {
    th: "条码支付系统",
    th2: "定制化支付清算解决方案",
    tips:
      "NuwaPay开发的QRPS系统是一款基于二维码技术的尖端产品，专为境外国家中央银行设计。无论是与现有清算系统的无缝对接，还是全新移动支付清算系统的搭建，QRPS都能灵活适配不同需求。QRPS的吸引力之一是它可以与银联国际等清算机构互联，实现基于移动支付的跨境货币结算。",
    sec: {
      t1: "定制化支付清算解决方案",
      tips1:
        "QRPS系统能够根据各国现有的金融基础设施进行定制，灵活地适配不同国家的需求。无论是与现有清算系统的对接，还是从零开始搭建新的移动支付清算系统，QRPS都能提供卓越的解决方案",
      t2: "增强监管和数据统计能力",
      tips2:
        "通过QRPS系统，中央银行可以大幅提升对交易的监管能力，并提供更精确的数据统计分析工具，为政策制定和市场监控提供有力支持。",
      t3: "跨境货币结算的便利性",
      tips3:
        "QRPS系统与银联国际等全球领先的清算机构互联，支持基于移动支付的跨境货币结算，帮助各国快速实现全球金融网络的对接。 ",
      t4: "系统优势",
      tips4:
        "QRPS系统具有高度的安全性和可扩展性，能够应对大规模交易的需求。该系统采用最新的加密技术，保障每一笔交易的安全，同时支持未来的扩展和功能升级。",
      t5: "全球适用性",
      tips5:
        "QRPS不仅适用于尼日利亚等单一国家，NuwaPay还计划将这一成功模式复制到其他发展中国家，助力全球范围内的数字支付转型。",
      t6: "用户体验和易用性",
      tips6:
        "QRPS系统设计注重用户体验，从央行管理者到普通用户，系统操作简单直观，用户可以轻松完成支付和清算操作。",
      t7: "案例研究: 尼日利亚NQR系统",
      tips7:
        "NuwaPay为尼日利亚央行成功搭建的NQR系统已全面上线，并在全国范围内推广。通过NQR系统，尼日利亚不仅实现了移动支付的普及，更建立了完善的监管与统计体系，成为移动支付领域的标杆。"
    }
  },
  tool: {
    th: "全功能即时通讯工具",
    tips:
      "NuwaPay自主研发的即时通讯工具-Budchat，是一款融合多种支付场景的即时通讯应用，内置银行级用户钱包功能，现已在尼日利亚全面上线，开启数字支付新时代。",
    sec: {
      t1: "多支付场景集成",
      tips1:
        "Budchat 不仅是一个通讯工具，更是一个满足 B2C（商户对消费者）、C2B（消费者对商户）、C2C（消费者对消费者）等多种支付需求的综合平台。通过该平台，用户可以在与朋友或商户沟通时轻松完成支付操作，提升了交易的便捷性和效率。",
      t2: "内置银行级用户钱包",
      tips2:
        "Budchat 内置的用户钱包采用银行级安全标准，支持在线电子钱包的快速开通，用户可以随时随地进行电子钱包转账、支付账单，甚至跨境交易。强大的安全加密技术确保了每一笔交易的安全性。",
      t3: "创新与便捷的支付体验",
      tips3:
        "Budchat 在设计上注重用户体验，提供无缝衔接的支付流程。用户可以直接在聊天界面中完成支付，方便又快捷，极大提升了日常交易的效率",
      t4: "在尼日利亚的全面上线与成功应用",
      tips4:
        "Budchat 已在尼日利亚全面上线，并迅速普及。凭借其强大的功能和安全保障，Budchat 在尼日利亚市场取得了广泛认可",
      t5: "隐私与数据安全",
      tips5:
        "Budchat 特别关注用户隐私，所有通讯和支付数据都经过多层加密处理，符合国际数据保护标准，确保用户的信息安全无虞。",
      t6: "用户界面与交互设计",
      tips6:
        "Budchat 的界面设计简洁直观，用户可以快速上手，轻松完成通讯与支付操作。支持多语言界面，满足不同地区用户的使用需求。"
    }
  },
  about: {
    th: "公司简介",
    tips:
      "新陆科技有限公司成立于2019年，由中国国内移动支付领域的巨头创始人共同创办。公司专注于帮助海外国家实现移动支付的数字化转型，向境外中央银行和收单机构提供先进的二维码技术服务和条形码支付结算系统。新陆科技成功为多个非洲国家完成了支付系统的搭建，并为当地用户和商家提供了移动钱包等增值服务及数字管理产品，全面覆盖支付生态系统中的各类场景，提供行业领先的解决方案。",
    tips2:
      "公司以客户成功为使命，在香港、新加坡、印尼、坦桑尼亚、尼日利亚、哈萨克斯坦等地设立了分支机构，构建了以“一带-路”为核心业务发展的跨境支付与资金清结算一站式平台，致力于为企业解决全球业务扩展中的资金收付难题，帮助企业实现全球范围内的资金安全、高效流转，提供货币兑换及结汇分发等服务。目前，力展控股已获得PCI-DSS国际支付行业安全认证，支付能力覆盖VISA、MASTERCARD、JCB等国际卡组织及100多个全球电子钱包收单服务。公司业务覆盖超过110个国家和地区，支持15种以上主流结算币种。"
  },
  conUs: {
    th: "联系我们",
    firstName: "姓氏",
    lastName: "名字",
    email: "工作邮箱",
    phone: "办公电话",
    companyName: "公司名称",
    companyAddress: "公司主要业务地区",
    check1: "我确认我已阅读NuwaPay的",
    check2: "隐私条款",
    check3: "，同意按照该政策使用我的数据。",
    submit: "提交",
    phr1: "三",
    phr2: "张",
    phr3: "请输入可联系到您的邮箱地址",
    phr4: "请输入您的手机号码",
    phr5: "地区",
    phr6: "请输入公司名称",
    phr7: "请输入公司主要业务地区"
  },
  address: {
    address: "公司地址",
    hk: "香港(Hong Kong SAR,China)"
  },

  error: {
    lastName: "请输入名字",
    firstName: "请输入姓氏",
    email: "请输入邮箱地址",
    phone: "请输入您的手机号码",
    area: "请选择地区",
    companyName: "请输入公司名称",
    checked: "请仔细阅读并同意NuwaPay的隐私条款."
  },
  login: {
    tit: "登录你的账户",
    txt: "欢迎回来，我们很想念你!",
    tips: "还没有NuwaPay账号?",
    tips2: "立即注册",
    logo: {
      txt: "登录NuwaPay账户"
    }
  }
};



// WEBPACK FOOTER //
// ./src/locale/lang/zh.js